import { Map } from 'immutable';
import actions from './actions';

const initialState = new Map({
  cancellingSubscription: false,
  cancellingSubscriptionFailed: null,
  cancelledSubscription: false,
});

export default function cancelSubscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case actions.DO_CANCEL_SUBSCRIPTION:
      return state
        .set('cancellingSubscription', true)
        .set('cancellingSubscriptionFailed', null)
        .set('cancelledSubscription', false)
    case actions.DO_CANCEL_SUBSCRIPTION_SUCCEEDED:
      return state
      .set('cancellingSubscription', false)
      .set('cancellingSubscriptionFailed', null)
      .set('cancelledSubscription', action.payload)
    case actions.DO_CANCEL_SUBSCRIPTION_FAILED:
      return state
      .set('cancellingSubscription', false)
      .set('cancellingSubscriptionFailed', action.payload)
      .set('cancelledSubscription', false)
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/cancelSubscription/reducer.js